export interface LoginRequest {
  email: string;
  password: string;
}

export interface WebServiceRegistryDto {
  name: string;
  email: string;
  phone: string;
  rfc: string;
  systemTag: string;
  retryCounter: number;
}

export interface WebServiceRegistryCode {
  message?: string;
  email: string;
  verificationCode?: number;
}

export interface MenuItem {
  title: string;
  path: string;
  link: string;
  data: any;
}

export interface LoginResponse {
  token: string;
  type: string;
  id: string;
  username: string;
  email: string;
  roles: string[];
  termsAndConditions: Boolean;
  menu: Array<MenuItem>;
}

export class NtError implements Error {
  readonly name = 'NtError';
  readonly message: string;
  readonly error: any | null;

  constructor(message: string, error?: any) {
    this.message = message;
    this.error = error;
  }
}
